import { jsx as _jsx } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
import { Portal } from '@fluentui/react-portal';
/**
 * Render the final JSX of MenuPopover
 */
export const renderMenuPopover_unstable = state => {
  assertSlots(state);
  if (state.inline) {
    return /*#__PURE__*/_jsx(state.root, {});
  }
  return /*#__PURE__*/_jsx(Portal, {
    mountNode: state.mountNode,
    children: /*#__PURE__*/_jsx(state.root, {})
  });
};